import { Handle, Position, useNodeConnections } from '@xyflow/react'

/**
 * One operand row for the operator nodes: a target pin + an inline literal box,
 * Unreal-Blueprint style. When the pin is WIRED the box simply disappears (the
 * wire drives the value — no extra label needed); when unconnected you type a
 * literal. The runtime prefers the wired value and falls back to the typed
 * literal (see EventRuntime `_resolveDataPin`). The literal is always a string;
 * the comparators coerce it (so "2", "true", "hello" all work).
 */

const stop = e => e.stopPropagation()

export function OperandRow({ nodeId, pinId, label, accent, pinColor, borderColor, value, onChange }) {
  const connections = useNodeConnections({ id: nodeId, handleType: 'target', handleId: pinId })
  const wired = connections.length > 0
  return (
    <div className="nodrag nowheel"
      style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '6px 12px 6px 16px', borderBottom: `1px solid ${borderColor}`, position: 'relative',
      }}
      onPointerDown={stop} onMouseDown={stop} onClick={stop}>
      <Handle type="target" position={Position.Left} id={pinId}
        style={{ background: pinColor, width: 10, height: 10, borderRadius: '50%', border: `2px solid ${pinColor}55` }} />
      <span style={{ color: accent, fontSize: 10, minWidth: 12 }}>{label}</span>
      {!wired && (
        <input
          type="text"
          value={value ?? ''}
          placeholder="value"
          aria-label={`operand ${label}`}
          onChange={e => onChange(e.target.value)}
          onPointerDown={stop} onMouseDown={stop} onClick={stop} onKeyDown={stop} onWheel={stop}
          style={{
            marginLeft: 'auto', width: 96, boxSizing: 'border-box',
            background: '#02100d', border: `1px solid ${accent}55`, color: '#dfe',
            borderRadius: 3, fontSize: 10, fontFamily: 'var(--m-mono)', padding: '3px 6px', outline: 'none',
          }}
        />
      )}
    </div>
  )
}
